import { render, staticRenderFns } from "./ColorTool.vue?vue&type=template&id=56e36071&scoped=true&"
import script from "./ColorTool.vue?vue&type=script&lang=js&"
export * from "./ColorTool.vue?vue&type=script&lang=js&"
import style0 from "./ColorTool.vue?vue&type=style&index=0&id=56e36071&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e36071",
  null
  
)

export default component.exports